import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-5xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center mr-3" }
const _hoisted_6 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_7 = { class: "px-6 py-6" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_10 = { class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-2" }
const _hoisted_11 = { class: "text-sm text-red-800 dark:text-red-300" }
const _hoisted_12 = { class: "mb-6" }
const _hoisted_13 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_14 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_15 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_16 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_17 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_18 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_19 = { class: "mt-1 text-gray-900 dark:text-white font-medium break-all" }
const _hoisted_20 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_21 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_22 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_23 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_24 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_25 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_26 = { class: "mb-6" }
const _hoisted_27 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_28 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_29 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_30 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_31 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_32 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_33 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_34 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_35 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_36 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_37 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_38 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_39 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_40 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_41 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_42 = { class: "mb-6" }
const _hoisted_43 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_44 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_45 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_46 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_47 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_48 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_49 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_50 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_51 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_52 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_53 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_54 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_55 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_56 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_57 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_58 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_59 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_60 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_61 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_62 = {
  key: 3,
  class: "mb-6"
}
const _hoisted_63 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_64 = { class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 0,
  class: "relative"
}
const _hoisted_67 = ["src", "alt"]
const _hoisted_68 = {
  key: 1,
  class: "relative"
}
const _hoisted_69 = { class: "absolute top-2 left-2 px-2 py-1 bg-black bg-opacity-70 rounded text-xs font-medium text-white" }
const _hoisted_70 = {
  key: 2,
  class: "absolute bottom-2 right-2 px-2 py-1 bg-black bg-opacity-70 rounded text-xs text-white"
}
const _hoisted_71 = { class: "sticky bottom-0 bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end space-x-3" }
const _hoisted_72 = ["src", "alt"]
const _hoisted_73 = { class: "absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-sm" }

import { ref } from 'vue';
import type { Claim, ClaimPhoto } from '@/types/claim';
import ViewIcon from '@/components/icons/ViewIcon.vue';
import EditIcon from '@/components/icons/EditIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClaimDetailsModal',
  props: {
    isOpen: { type: Boolean },
    claim: {}
  },
  emits: ["close", "edit"],
  setup(__props: any) {

const props = __props;



// Lightbox state
const lightboxOpen = ref(false);
const currentPhotoIndex = ref(0);

// function getPhotoUrl(path: string): string {
//   const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
//   // Remove /api or /api/public from the URL to get the base URL
//   const baseUrl = apiUrl.replace(/\/api(\/public)?$/, '');
//   return `${baseUrl}/storage/${path}`;
// }

function getPhotoUrl(path: string): string {
  const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
  // const baseUrl = process.env.VUE_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';
  return `${baseUrl}/storage/${path}`;
}

function openLightbox(index: number) {
  currentPhotoIndex.value = index;
  lightboxOpen.value = true;
}

function closeLightbox() {
  lightboxOpen.value = false;
}

function previousPhoto() {
  if (currentPhotoIndex.value > 0) {
    currentPhotoIndex.value--;
  }
}

function nextPhoto() {
  if (props.claim?.claim_photos && currentPhotoIndex.value < props.claim.claim_photos.length - 1) {
    currentPhotoIndex.value++;
  }
}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

function getStatusClass(status: string): string {
  switch (status) {
    case 'under review':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
    case 'approved':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
    case 'ready for pick-up':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
    case 'fulfilled':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
  }
}

function getStatusDotClass(status: string): string {
  switch (status) {
    case 'under review':
      return 'bg-yellow-500 dark:bg-yellow-400';
    case 'approved':
      return 'bg-green-500 dark:bg-green-400';
    case 'rejected':
      return 'bg-red-500 dark:bg-red-400';
    case 'ready for pick-up':
      return 'bg-blue-500 dark:bg-blue-400';
    case 'fulfilled':
      return 'bg-purple-500 dark:bg-purple-400';
    default:
      return 'bg-gray-500 dark:bg-gray-400';
  }
}

// Check if media is a video
function isVideo(photo: ClaimPhoto): boolean {
  return photo.media_type === 'damage_video';
}

// Get human-readable label for media type
function getMediaLabel(mediaType?: string): string {
  switch (mediaType) {
    case 'whole_tire':
      return 'Whole Tire';
    case 'tread_view':
      return 'Tread View';
    case 'damage_video':
      return 'Damage Video';
    default:
      return 'Media';
  }
}

// Format file size from bytes to human-readable format
function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  } else {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
}

// Handle media click (lightbox for photos, video playback for videos)
function handleMediaClick(photo: ClaimPhoto, index: number) {
  if (isVideo(photo)) {
    // Open video in new tab for playback
    const videoUrl = getPhotoUrl(photo.photo_path);
    window.open(videoUrl, '_blank');
  } else {
    // Open lightbox for photos
    openLightbox(index);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          (_ctx.isOpen && _ctx.claim)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-50 overflow-y-auto",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
              }, [
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(ViewIcon, { classes: "h-5 w-5 text-blue-600 dark:text-blue-400" })
                        ]),
                        _createElementVNode("div", null, [
                          _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Claim Details ", -1)),
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.claim.claim_number), 1)
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                        class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("svg", {
                          class: "h-6 w-6",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2 block" }, " Claim Status ", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass([getStatusClass(_ctx.claim.claim_status), "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium"])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["w-2 h-2 rounded-full mr-2", getStatusDotClass(_ctx.claim.claim_status)])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(_ctx.claim.claim_status), 1)
                        ], 2)
                      ]),
                      (_ctx.claim.claim_status === 'rejected' && _ctx.claim.rejection_reason)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2 block" }, " Rejection Reason ", -1)),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.claim.rejection_reason), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h3", _hoisted_13, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[9] || (_cache[9] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                              "clip-rule": "evenodd"
                            }, null, -1)
                          ]))),
                          _cache[10] || (_cache[10] = _createTextVNode(" Customer Information "))
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[11] || (_cache[11] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Customer Name", -1)),
                            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.claim.user?.first_name) + " " + _toDisplayString(_ctx.claim.user?.last_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Email", -1)),
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.claim.user?.email || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Mobile Number", -1)),
                            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.claim.user?.user_detail?.mobile || _ctx.claim.user?.userDetail?.mobile || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _cache[14] || (_cache[14] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Brand", -1)),
                            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.claim.brand?.brand_name || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _cache[15] || (_cache[15] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Date Submitted", -1)),
                            _createElementVNode("p", _hoisted_25, _toDisplayString(formatDate(_ctx.claim.created_at)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5 mr-2 text-blue-600 dark:text-blue-400",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" }),
                            _createElementVNode("circle", {
                              cx: "7",
                              cy: "17",
                              r: "2"
                            }),
                            _createElementVNode("path", { d: "M9 17h6" }),
                            _createElementVNode("circle", {
                              cx: "17",
                              cy: "17",
                              r: "2"
                            })
                          ]),
                          _createTextVNode(" Vehicle Information ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Year", -1)),
                            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.claim.vehicle?.vehicle_year || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _cache[17] || (_cache[17] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Make", -1)),
                            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.claim.vehicle?.vehicle_make || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _cache[18] || (_cache[18] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Model", -1)),
                            _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.claim.vehicle?.vehicle_model || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _cache[19] || (_cache[19] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Plate Number", -1)),
                            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.claim.vehicle?.plate_number || 'N/A'), 1)
                          ])
                        ])
                      ]),
                      (_ctx.claim.videocall_schedule)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("h3", _hoisted_37, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_38, _cache[21] || (_cache[21] = [
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "4",
                                  width: "18",
                                  height: "18",
                                  rx: "2",
                                  ry: "2"
                                }, null, -1),
                                _createElementVNode("line", {
                                  x1: "16",
                                  y1: "2",
                                  x2: "16",
                                  y2: "6"
                                }, null, -1),
                                _createElementVNode("line", {
                                  x1: "8",
                                  y1: "2",
                                  x2: "8",
                                  y2: "6"
                                }, null, -1),
                                _createElementVNode("line", {
                                  x1: "3",
                                  y1: "10",
                                  x2: "21",
                                  y2: "10"
                                }, null, -1)
                              ]))),
                              _cache[22] || (_cache[22] = _createTextVNode(" Video Call Schedule "))
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", {
                                  class: "text-xs font-medium uppercase tracking-wide",
                                  style: {"color":"var(--brand-primary)"}
                                }, "Scheduled Date & Time", -1)),
                                _createElementVNode("p", _hoisted_41, _toDisplayString(formatDate(_ctx.claim.videocall_schedule)), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_42, [
                        _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5 mr-2 text-blue-600 dark:text-blue-400",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "9"
                            }),
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "5"
                            }),
                            _createElementVNode("path", { d: "M12 3v2M12 19v2M3 12h2M19 12h2" })
                          ]),
                          _createTextVNode(" Tire Information ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _cache[24] || (_cache[24] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Pattern", -1)),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.claim.tire?.pattern || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _cache[25] || (_cache[25] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Size", -1)),
                            _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.claim.tire?.tire_size || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "DOT", -1)),
                            _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.claim.tire?.dot || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Position", -1)),
                            _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.claim.tire?.tire_position || 'N/A'), 1)
                          ])
                        ])
                      ]),
                      (_ctx.claim.dealer)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _createElementVNode("h3", _hoisted_53, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_54, _cache[29] || (_cache[29] = [
                                _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }, null, -1),
                                _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" }, null, -1)
                              ]))),
                              _cache[30] || (_cache[30] = _createTextVNode(" Replacement Tire Dealer "))
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _cache[31] || (_cache[31] = _createElementVNode("label", {
                                  class: "text-xs font-medium uppercase tracking-wide",
                                  style: {"color":"var(--brand-primary)"}
                                }, "Dealer Name", -1)),
                                _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.claim.dealer.dealer_name || 'N/A'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _cache[32] || (_cache[32] = _createElementVNode("label", {
                                  class: "text-xs font-medium uppercase tracking-wide",
                                  style: {"color":"var(--brand-primary)"}
                                }, "Address", -1)),
                                _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.claim.dealer.dealer_address || 'N/A'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                _cache[33] || (_cache[33] = _createElementVNode("label", {
                                  class: "text-xs font-medium uppercase tracking-wide",
                                  style: {"color":"var(--brand-primary)"}
                                }, "Contact", -1)),
                                _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.claim.dealer.dealer_contact || 'N/A'), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.claim.claim_photos && _ctx.claim.claim_photos.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("h3", _hoisted_63, [
                              _cache[34] || (_cache[34] = _createElementVNode("svg", {
                                class: "w-5 h-5 mr-2 text-blue-600 dark:text-blue-400",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2"
                              }, [
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "3",
                                  width: "18",
                                  height: "18",
                                  rx: "2",
                                  ry: "2"
                                }),
                                _createElementVNode("circle", {
                                  cx: "9",
                                  cy: "9",
                                  r: "2"
                                }),
                                _createElementVNode("path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" })
                              ], -1)),
                              _createTextVNode(" Photos & Video (" + _toDisplayString(_ctx.claim.claim_photos.length) + ") ", 1)
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claim.claim_photos, (photo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: photo.claim_photo_id,
                                  class: "relative group cursor-pointer",
                                  onClick: ($event: any) => (handleMediaClick(photo, index))
                                }, [
                                  (!isVideo(photo))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                        _createElementVNode("img", {
                                          src: getPhotoUrl(photo.photo_path),
                                          alt: getMediaLabel(photo.media_type),
                                          class: "w-full h-32 object-cover rounded-lg border-2 border-gray-200 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 transition-all duration-200"
                                        }, null, 8, _hoisted_67),
                                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-200 rounded-lg flex items-center justify-center" }, [
                                          _createElementVNode("svg", {
                                            class: "w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                                            })
                                          ])
                                        ], -1))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_68, _cache[36] || (_cache[36] = [
                                        _createElementVNode("div", { class: "w-full h-32 bg-gray-200 dark:bg-gray-900 rounded-lg border-2 border-gray-200 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 transition-all duration-200 flex items-center justify-center" }, [
                                          _createElementVNode("svg", {
                                            class: "w-12 h-12 text-gray-500 dark:text-gray-400",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                                            }),
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                            })
                                          ])
                                        ], -1),
                                        _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-200 rounded-lg" }, null, -1)
                                      ]))),
                                  _createElementVNode("div", _hoisted_69, _toDisplayString(getMediaLabel(photo.media_type)), 1),
                                  (photo.file_size)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(formatFileSize(photo.file_size)), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_65))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                      }, " Close "),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('edit', _ctx.claim))),
                        class: "px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg transition-colors duration-200 flex items-center space-x-2"
                      }, [
                        _createVNode(EditIcon, { classes: "h-5 w-5" }),
                        _cache[37] || (_cache[37] = _createElementVNode("span", null, "Edit Claim", -1))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (lightboxOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-[60] bg-black bg-opacity-90 flex items-center justify-center p-4",
                onClick: closeLightbox
              }, [
                _createElementVNode("button", {
                  onClick: closeLightbox,
                  class: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                }, _cache[39] || (_cache[39] = [
                  _createElementVNode("svg", {
                    class: "h-8 w-8",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ])),
                (currentPhotoIndex.value > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _withModifiers(previousPhoto, ["stop"]),
                      class: "absolute left-4 text-white hover:text-gray-300 transition-colors duration-200"
                    }, _cache[40] || (_cache[40] = [
                      _createElementVNode("svg", {
                        class: "h-12 w-12",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 19l-7-7 7-7"
                        })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (_ctx.claim?.claim_photos && _ctx.claim.claim_photos[currentPhotoIndex.value])
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: getPhotoUrl(_ctx.claim.claim_photos[currentPhotoIndex.value].photo_path),
                      alt: `Damage photo ${currentPhotoIndex.value + 1}`,
                      class: "max-w-full max-h-full object-contain",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, _hoisted_72))
                  : _createCommentVNode("", true),
                (_ctx.claim?.claim_photos && currentPhotoIndex.value < _ctx.claim.claim_photos.length - 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: _withModifiers(nextPhoto, ["stop"]),
                      class: "absolute right-4 text-white hover:text-gray-300 transition-colors duration-200"
                    }, _cache[41] || (_cache[41] = [
                      _createElementVNode("svg", {
                        class: "h-12 w-12",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 5l7 7-7 7"
                        })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_73, _toDisplayString(currentPhotoIndex.value + 1) + " / " + _toDisplayString(_ctx.claim?.claim_photos?.length || 0), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}
}

})